import { Heart, Gem, MapPin, Award, CheckCircle2 } from "lucide-react";
import { BENEFITS } from "@/data/site";

const ICONS = { Heart, Gem, MapPin, Award };

export default function Benefits() {
  return (
    <section
      id="benefits"
      data-testid="benefits-section"
      className="relative py-20 md:py-40 bg-[#080808] overflow-hidden"
    >
      {/* faint gold radial */}
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#D4AF37]/10 blur-[140px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-14 items-start relative">
        {/* Left: typographic */}
        <div className="lg:col-span-6 lg:sticky lg:top-32">
          <p className="eyebrow reveal">02 — Why Cutting Edge</p>
          <h2 className="font-display text-white font-light text-4xl md:text-6xl tracking-tighter mt-4 leading-[1.02] reveal">
            Trust isn’t marketed. It’s{" "}
            <span className="font-serif italic text-[#D4AF37]">earned</span> —
            one panel at a time.
          </h2>
          <p className="text-white/60 mt-7 max-w-lg leading-relaxed reveal">
            We are a small, family operated studio led by Warren Edgecombe.
            Vehicles are not booked through a queue here — they are studied,
            understood, and treated to the level of care we would give our own.
          </p>

          <ul className="mt-10 space-y-4 reveal">
            {[
              "No cutting corners. Ever.",
              "Honest assessments before any work begins.",
              "Premium-grade products, period.",
              "Mobile to your driveway when needed.",
            ].map((line) => (
              <li key={line} className="flex items-start gap-3 text-white/75">
                <CheckCircle2 className="w-5 h-5 text-[#D4AF37] mt-0.5 shrink-0" />
                <span className="text-sm md:text-base">{line}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Right: cards staggered + image */}
        <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {BENEFITS.map((b, i) => {
            const Icon = ICONS[b.iconKey] || Heart;
            return (
              <div
                key={b.title}
                data-testid={`benefit-card-${i}`}
                className={`glass-card p-6 reveal ${
                  i % 2 === 1 ? "sm:translate-y-10" : ""
                }`}
                style={{ transitionDelay: `${i * 90}ms` }}
              >
                <div className="w-10 h-10 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] mb-5">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-display text-white text-xl tracking-tight">
                  {b.title}
                </h3>
                <p className="text-white/55 text-sm mt-3 leading-relaxed">
                  {b.desc}
                </p>
              </div>
            );
          })}

          <div className="sm:col-span-2 relative h-72 overflow-hidden border border-white/5 reveal">
            <img
              src="https://images.unsplash.com/photo-1771491237225-01931a752f58?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYXIlMjBkZXRhaWxpbmclMjBwcm9jZXNzfGVufDB8fHx8MTc3NzI2NDgzNHww&ixlib=rb-4.1.0&q=85"
              alt="Detailing process"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
            <div className="absolute bottom-5 left-5 right-5">
              <p className="text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">
                Inside the studio
              </p>
              <p className="text-white text-lg font-display mt-1">
                Patience over speed. Quality over volume.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
